import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=42cc0576&"
import script from "./Individual.vue?vue&type=script&lang=js&"
export * from "./Individual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports